<template>
  <div>
    <p>&#x203B; 表示金額はすべて税抜き価格となっております。</p>
    <div class="get-free-delivery">
      <h3>送料無料特典</h3>
      <div v-if="order.city === null">
        配達先住所を入力してください。
      </div>
      <div v-else-if="calculationResult.need_to_be_free_delivery >= 0">
        <p>
          <span class="new-line">お料理の金額が</span>
          <span class="new-line">あと<span class="hoge">{{calculationResult.need_to_be_free_delivery | currency}}分</span>で</span>
          <span class="piyo">送料({{calculationResult.delivery_price | currency}})無料!!</span>
        </p>
        <p class="caution">
          &#x203B; お料理以外の料金は上記に含まれません。
        </p>
      </div>
      <div class="text-danger font-size-large" v-else>
        送料({{calculationResult.delivery_price}}円)が無料になりました！
      </div>
    </div>

    <!-- 選択したプラン -->
    <div class="block">
      <h2>選択中のプラン</h2>
      <div class="row">
        <div class="col-12">
          <div class="selected-plan">
            <div class="mb-2">
              <span class="label label-order_type">{{orderTypeJa[orderProps.order_type]}}</span>
              <span class="label label-meal_type">{{mealTypeJa[orderProps.meal_type]}}</span>
            </div>
            <h3>
              {{orderProps.plan_name}}
              <span style="font-weight: normal">{{orderProps.plan_price | currency}}</span>
            </h3>
            <dl>
              <dt>最低注文人数</dt>
              <dd>{{orderProps.minimum_quantity}}人</dd>
            </dl>
            <dl v-if="order.order_type === 'catering'">
              <dt>最低注文人数(ドリンク注文時)</dt>
              <dd>{{orderProps.minimum_quantity_with_drink_plan}}人</dd>
            </dl>
            <div class="customer-caution" v-if="orderProps.customer_caution">
              <dd>{{orderProps.customer_caution}}</dd>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ul class="errors alert alert-danger" v-if="errors.fullMessages.length > 0">
      <li v-for="message in errors.fullMessages">{{message}}</li>
    </ul>

    <form>
      <div id="order-information" class="block">
        <!-- 人数 -->
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">人数</label>
              <input name="quantity" class="form-control" type="number" min="1"
                     v-model="order.quantity"
                     @input="calculate(); validatesQuantity()"
                     @change="updatePlateQuantity"
                     inputmode="numeric">
              <ul class="errors alert alert-danger mt-2" v-if="errors.messages.quantity.length > 0">
                <li v-for="message in errors.messages.quantity">{{message}}</li>
              </ul>
            </div>
          </div>

          <!--場所 -->
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（都道府県）</label>
              <select name="prefecture" v-model="order.prefecture" class="form-control" @chage="calculate">
                <option disabled value="">都道府県を選択</option>
                <option v-for="prefecture in ['東京都', '神奈川県', '埼玉県', '千葉県']">{{prefecture}}</option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（市区）</label>
              <select name="city" class="form-control" v-model="order.city" @change="calculate">
                <option disabled value="">市区を選択</option>
                <option v-for="priceTable in filteredDeliveryPriceTable">{{priceTable.attributes.city}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- 料理変更 -->
      <div id="change-dish" class="block" v-if="plan.customizations && plan.customizations.length > 0">
        <h2>料理変更</h2>
        <div style="max-height: 200px; overflow-y: scroll; border: 1px solid #ccc; padding: 20px;">
          <div class="row mb-2" v-for="customization in plan.customizations" :key="customization.id">
            <div class="col-12">
              <label>
                <input type="checkbox" :value="{description: customization.description}"
                       v-model="order.customizations">
                <span class="font-size-large">{{customization.description}}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- ドリンク類 -->
      <template v-if="drinkAvailable && order.order_type === 'delivery'">
        <!-- デリバリーの場合、23区内以外はカクヤスが配達できないためドリンクの注文は不可 -->
        <template v-if="order.prefecture === '東京都' && order.city && order.city.includes('区')">
          <div class="block">
            <!-- ドリンクセット -->
            <div id="drink-sets" class="row">
              <div class="col-12">
                <h2>ドリンクセットの追加はこちら</h2>
                <div class="option-area">
                  <p>
                    ドリンクセットの追加はこちらから。セット入力で料金に反映されます。<br>
                    <span class="text-danger">未成年の方にアルコールのご提供はできません。</span>
                  </p>
                  <div class="option-list">
                    <DrinkSetOption
                        v-for="(drinkSet, index) in drinkSetOptions"
                        :key="index"
                        :drinkSet="drinkSet"
                        @calculate="calculate"
                        @handleDrinkSet="handleDrinkSet"
                    ></DrinkSetOption>
                  </div>
                </div>
              </div>
            </div>

            <!-- ドリンク(単品) -->
            <div id="drinks" class="row mt-4">
              <div class="col-12">
                <h2>ドリンク(単品)の追加はこちらから</h2>
                <div class="option-area">
                  <p>
                    ドリンクの追加はこちらから。必要本数入力で料金に反映されます。<br>
                    <span class="text-danger">未成年の方にアルコールのご提供はできません。</span>
                  </p>
                  <div class="option-list">
                    <DrinkOption
                        v-for="(drink, index) in drinkOptions.filter(option => option.kind !== 'other')"
                        :key="index"
                        :drink="drink"
                        @calculate="calculate"
                        @handleDrink="handleDrink"
                    ></DrinkOption>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <div class="alert alert-danger" v-if="order.drinks.find(drink => drink.kind === 'alcohol') || order.drink_sets.length > 0">
                  <input id="alcohol_policy_agreement" name="alcohol_policy_agreement" type="checkbox" v-model="order.alcohol_policy_agreement">
                  <label for="alcohol_policy_agreement" class="font-size-large">20歳以上です</label>
                  <div>&#x203B; 未成年者の飲酒は法律で禁じられております。上記チェックがない場合はお酒のデリバリーは行えませんのでご了承くださいませ。</div>
                </div>
              </div>
            </div>

            <!-- 備品 -->
            <div id="equipments" class="row mt-4">
              <div class="col-12">
                <h2>備品の追加はこちらから</h2>
                <div class="option-area">
                  <p> 備品の追加はこちらから。人数入力で料金に反映されます。 </p>
                  <div class="option-list">
                    <DrinkOption
                        v-for="(drink, index) in drinkOptions.filter(option => option.kind === 'other')"
                        :key="index"
                        :drink="drink"
                        @calculate="calculate"
                        @handleDrink="handleDrink"
                    ></DrinkOption>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-12">
              <h2>ドリンクはこちらから</h2>
              <div class="alert alert-danger">
                デリバリーの場合、ドリンクの注文は23区内のみ可能となります。
              </div>
            </div>
          </div>
        </template>
      </template>

      <!-- ドリンクプラン -->
      <div v-if="order.order_type === 'catering'" id="drink-plan" class="block">
        <div class="row">
          <div class="col-12">
            <h2>ドリンクプランはこちらから</h2>
            <div class="option-area">
              <p>
                ドリンクプランの追加はこちらから。人数入力で料金に反映されます。<br>
                <span class="text-danger mt-3">
                  ドリンクプランをご注文の場合、お料理の人数分の注文をお願いしております。(人数以下をご希望の場合はご相談ください)
                  <br>
                  未成年の方にアルコールのご提供はできません。
                </span>
              </p>
              <!-- <div v-if="drinkPlanMinimumQuantityWarning" class="alert alert-danger">ドリンクセットをご注文の場合、お料理の人数分の注文が必要です。</div> -->
              <ul class="alert alert-danger" v-if="invalidDrinkPlanCombinationMessages.length > 0">
                <li v-for="message in invalidDrinkPlanCombinationMessages">{{message}}</li>
              </ul>
              <div class="option-list">
                <DrinkPlanOption
                    v-for="(drinkPlan, index) in drinkPlanOptions"
                    :key="index"
                    :drinkPlan="drinkPlan"
                    @calculate="calculate"
                    @validatesQuantity="validatesQuantity"
                    @handleDrinkPlan="handleDrinkPlan"
                ></DrinkPlanOption>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 追加料理 -->
      <div id="dishes" class="block" v-if="['buffet', 'finger'].includes(order.meal_type)">
        <div class="row">
          <div class="col-12">
            <h2>追加料理はこちらから</h2>
            <div class="option-area">
              <p>
                料理の追加はこちらから。人数入力で料金に反映されます。<br>
                <span class="text-danger" v-if="order.quantity">{{dishMinimumQuantity}}名以上のご注文をお願いしております。</span>
              </p>
              <div class="option-list">
                <DishOption
                    v-for="(dish, index) in dishOptions"
                    :key="index"
                    :dish="dish"
                    :minimumQuantity="dishMinimumQuantity"
                    @calculate="calculate"
                    @handleDish="handleDish"
                ></DishOption>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 取皿　発熱剤　テーブルクロスの利用 -->
      <div id="option">
        <div class="block" v-if="order.order_type === 'delivery' && ['buffet', 'finger'].includes(order.meal_type)">
          <div class="mb-3">
            <h2>取皿セットの利用</h2>
            <div class="row mb-3">
              <div class="col-12 col-md-6 d-flex">
                <div class="radio-button-box">
                  <input id="use-plate-true" name="use_plate" type="radio" :value="true" v-model="order.use_plate" @change="calculate">
                  <label for="use-plate-true">使用する</label>
                </div>
                <div class="radio-button-box">
                  <input id="use-plate-false" name="use_plate" type="radio" :value="false" v-model="order.use_plate" @change="calculate">
                  <label for="use-plate-false">使用しない</label>
                </div>
              </div>
            </div>
            <div class="row mb-3" v-if="order.use_plate">
              <div class="col-12 col-md-4">
                <div class="input-group">
                  <input name="plate_quantity" type="number" min="1" v-model="order.plate_quantity" @input="calculate" class="form-control" placeholder="ご希望の数を入力" inputmode="numeric">
                  <div class="input-group-append">
                    <span class="input-group-text">セット</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="alert alert-warning">
                  【・お箸・取り皿・おしぼり・紙トング】
                  <br>
                  の四点セットを、お一人様30円にてご提供させていただいております。
                  <br>
                  &#x203B; 取皿セット不要の場合はトングも付きません。
                </p>
              </div>
            </div>
          </div>

          <div v-if="plan.required_exothermic_agent_quantity > 0 && ['type1', 'type2'].includes(plan.exothermic_agent_quantity_calculation_type)">
            <h2>発熱剤の利用</h2>
            <p>
              料理を温めるものです。(1皿300円)
              <a href="https://catering-season.com/exothermic-agent" target="_blank">発熱剤の使い方はこちら</a>
            </p>
            <div class="row">
              <div class="col-12 col-md-6 d-flex">
                <div class="radio-button-box">
                  <input id="exothermic-agent-true" name="exothermic_agent" type="radio" v-model="order.use_exothermic_agent" :value="true" @change="calculate">
                  <label for="exothermic-agent-true">使用する</label>
                </div>
                <div class="radio-button-box">
                  <input id="exothermic-agent-false" name="exothermic_agent" type="radio" v-model="order.use_exothermic_agent" :value="false" @change="calculate">
                  <label for="exothermic-agent-false">使用しない</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="block" v-if="order.order_type === 'catering'">
          <div class="row">
            <div class="col-12">
              <h2>テーブルクロスの利用</h2>
              <p>1000円にて必要枚数をご用意します。</p>
              <p>
                こちらが用意した料理とドリンクをご提供するテーブルのみにおつけします。<br>
                準備時間が短い場合やテーブルの形状によっては、テーブルクロスをおつけできない場合がございます。
              </p>
            </div>

            <div class="col-12 col-md-6">
              <div class="radio-button-inline">
                <div class="radio-button-box">
                  <input id="use-tablecloth-true" type="radio" :value="true" v-model="order.use_tablecloth" @change="calculate">
                  <label for="use-tablecloth-true">使用する</label>
                </div>
                <div class="radio-button-box">
                  <input id="use-tablecloth-false" type="radio" :value="false" v-model="order.use_tablecloth" @change="calculate">
                  <label for="use-tablecloth-false">使用しない</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 見積り -->
      <div class="block">
        <div class="quick-estimate-wrapper">
          <EstimateField
              :order="order"
              :calculationResult="calculationResult"
          ></EstimateField>

          <!-- 見積りモーダル -->
          <button @click.prevent="showEstimateModal" class="mt-2 btn btn-primary">見積書を確認</button>
          <Modal title="見積もり" v-if="shouldShowEstimateModal" @close="hideEstimateModal">
            <Estimate
                :order="order"
                :calculationResult="calculationResult"
                @downloadEstimate="downloadEstimate"
            ></Estimate>
          </Modal>
        </div>
      </div>

      <!-- 配達情報 -->
      <div id="delivery-date" class="block">
        <h2>配達日時</h2>

        <!-- 配達日時(ケータリング） -->
        <div class="row" v-if="order.order_type == 'catering'">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達日</label>
              <Datepicker
                  name='catering_on'
                  :language="ja"
                  :disabled-dates="disabledDates"
                  format="yyyy年MM月dd日(D)"
                  input-class="form-control datepicker"
                  v-model="order.catering_on"
              >
              </Datepicker>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">開始予定時間</label>
              <select name="catering_start_at" class="form-control" v-model="order.catering_start_at">
                <option disabled value="">開始予定時間を選択</option>
                <option v-for="time in timeOptions(11, 20)" :value="time">{{time}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">終了予定時間</label>
              <select name="catering_end_at" class="form-control" v-model="order.catering_end_at">
                <option disabled value="">終了予定時間を選択</option>
                <option v-for="time in timeOptions(11, 22)" :value="time">{{time}}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- 配達日時(デリバリー） -->
        <div class="row" v-if="order.order_type == 'delivery'">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="required">配達日</label>
              <Datepicker
                  name='delivery_on'
                  :language="ja"
                  :disabled-dates="disabledDates"
                  format="yyyy年MM月dd日(D)"
                  input-class="form-control datepicker"
                  v-model="order.delivery_on"
              ></Datepicker>
              <template v-if="isSeventeenPassed">
                <div class="alert alert-danger mt-2">翌日のご予約をご希望の場合はご注文をお受けできない場合がございます。予約送信後にお電話でご相談ください。</div>
              </template>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達時間</label>
              <select name="delivery_time_range" class="form-control" v-model="order.delivery_time_range">
                <option disabled value="">配達時間を選択</option>
                <option v-for="time in timeRangeOptions(10, 20)" :value="time">{{time}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div id="delivery-address" class="block">
        <h2>配達住所</h2>
        <!--場所 -->
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（都道府県）</label>
              <select name="prefecture" v-model="order.prefecture" class="form-control">
                <option disabled value="">都道府県を選択</option>
                <option v-for="prefecture in ['東京都', '神奈川県', '埼玉県', '千葉県']">{{prefecture}}</option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（市区）</label>
              <select name="city" class="form-control" v-model="order.city" @change="calculate">
                <option disabled value="">市区を選択</option>
                <option v-for="priceTable in filteredDeliveryPriceTable">{{priceTable.attributes.city}}</option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（町村・番地）</label>
              <input name="address" class="form-control" type="text" v-model="order.address" placeholder="例) 野沢2-14-1">
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>配達先住所（建物名）※階数や部屋番号も必ずご入力ください</label>
              <input name="building_name" class="form-control" type="text" v-model="order.building_name" placeholder="例) 雨宮ビル1階">
            </div>
          </div>
        </div>
      </div>

      <!-- お客様情報 -->
      <div id="customer-information" class="block">
        <h2>お客様情報</h2>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="required">ご担当者名</label>
              <input name="customer_name" type="text" class="form-control" v-model="order.customer_name">
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>法人名・団体名</label>
              <input name="group_name" type="text" class="form-control" v-model="order.group_name">
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="required">電話番号</label>
              <input name="tel" type="text" class="form-control" v-model="order.tel" inputmode="tel">
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="required">メールアドレス</label>
              <input name="email" type="text" class="form-control" v-model="order.email" :disabled="this.currentCustomer" inputmode="email">
            </div>
          </div>
        </div>
      </div>

      <!-- 支払い方法 & 注文に関するご要望・ご質問 -->
      <div id="payment-information" class="block">
        <h2>お支払い情報</h2>
        <!-- 支払い方法 -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="required">支払い方法</label>
              <select class="form-control" name="payment_method" v-model="order.payment_method">
                <option disabled value="">支払い方法を選択</option>
                <option v-for="(v, k) in paymentMethodOptions" :value="k">{{v}}</option>
              </select>
            </div>
          </div>
        </div>

        <template v-if="['before_bank_transfer', 'later_bank_transfer'].includes(order.payment_method)">
          <div class="row mt-3">
            <!-- 請求書宛名 -->
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>請求書の宛名</label>
                <span class="d-block">指定がない場合は「法人名・団体名」を記載します。</span>
                <input type="text" class="form-control" v-model="order.invoice_address">
              </div>
            </div>
          </div>
        </template>

        <template v-if="['cash', 'pay'].includes(order.payment_method)">
          <div class="row mt-3">
            <div class="col-12 col-md-6 mb-1">
              <div class="required font-weight-bolder mb-1">領収書の要否</div>
              <div class="d-flex">
                <div class="radio-button-box">
                  <input id="need-receipt-true" name="need_receipt" type="radio" :value="true" v-model="order.need_receipt">
                  <label for="need-receipt-true">必要</label>
                </div>
                <div class="radio-button-box">
                  <input id="need-receipt-false" name="need_receipt" type="radio" :value="false" v-model="order.need_receipt">
                  <label for="need-receipt-false">不要</label>
                </div>
              </div>
            </div>
          </div>

          <template v-if="order.need_receipt">
            <div class="row mt-3">
              <!-- 領収書但し書き -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>領収書の但し書きの指定がある場合は入力して下さい</label>
                  <span class="d-block">指定がない場合は「ケータリング代として」と記載します。</span>
                  <input name="receipt_proviso" type="text" class="form-control" v-model="order.receipt_proviso" placeholder="例) ケータリング代として">
                </div>
              </div>

              <!--領収書宛名指定 -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>領収書の宛名の指定がある場合は入力して下さい</label>
                  <span class="d-block">指定がない場合は宛名は記載しません。</span>
                  <input name="receipt_address" type="text" class="form-control" v-model="order.receipt_address" placeholder="例) 鈴木 一郎">
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>

      <div class="block">
        <!-- ご注文に関するご要望・ご質問 -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>ご注文に関するご要望・ご質問</label>
              <textarea class="form-control" rows="3" v-model="order.request"></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- 会場情報 -->
      <div id="about-venue" class="block" v-if="order.order_type === 'catering'">
        <div class="row">
          <div class="col-12 mb-1">
            <div class="my-2 alert alert-warning">
              ご注文の日時や人数によってはご注文をお受けできない場合がございます。<br>
              その場合は、メールまたは電話にてご連絡致します。
            </div>
          </div>
        </div>
        <h2>会場情報</h2>
        <div class="row mb-3">
          <div class="col-12 col-md-6 mb-1">
            <div class="d-flex">
              <div class="radio-button-box">
                <input id="input-yourself-true" type="radio" value="input_yourself" v-model="about_venue">
                <label for="input-yourself-true">いま入力する</label>
              </div>
              <div class="radio-button-box">
                <input id="input-yourself-false" type="radio" value="contact_me" v-model="about_venue">
                <label for="input-yourself-false">あとで入力する</label>
              </div>
            </div>
          </div>
        </div>

        <template v-if="about_venue === 'contact_me'">
          <div class="my-2 alert alert-warning">
            予約リクエスト送信後にメールをお送りします。<br>
            入力画面からご入力お願いいたします。
          </div>
        </template>
        <template v-if="about_venue === 'input_yourself'">
          <div class="row">
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">入館手続き</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-admission-procedure-true" name="catering_admission_procedure" type="radio" :value="true" v-model="order.catering_admission_procedure">
                    <label for="catering-admission-procedure-true">必要</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-admission-procedure-false" name="catering_admission_procedure" type="radio" :value="false" v-model="order.catering_admission_procedure">
                    <label for="catering-admission-procedure-false">不要</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">エレベーター</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-elevator-true" name="catering_elevator" type="radio" :value="true" v-model="order.catering_elevator">
                    <label for="catering-elevator-true">有り</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-elevator-false" name="catering_elevator" type="radio" :value="false" v-model="order.catering_elevator">
                    <label for="catering-elevator-false">無し</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">台車</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-wagon-true" name="catering_wagon" type="radio" :value="true" v-model="order.catering_wagon">
                    <label for="catering-wagon-true">可</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-wagon-false" name="catering_wagon" type="radio" :value="false" v-model="order.catering_wagon">
                    <label for="catering-wagon-false">不可</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">固形燃料の使用</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-solid-fuel-using-true" name="catering_solid_fuel_using" type="radio" :value="true" v-model="order.catering_solid_fuel_using">
                    <label for="catering-solid-fuel-using-true">可</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-solid-fuel-using-false" name="catering_solid_fuel_using" type="radio" :value="false" v-model="order.catering_solid_fuel_using">
                    <label for="catering-solid-fuel-using-false">不可</label>
                  </div>
                </div>
                <p>&#x203B; お料理を温めるのに火を使用しますが、煙は出ません。</p>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">駐車場の有無</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-parking-true" name="catering_parking" type="radio" :value="true" v-model="order.catering_parking">
                    <label for="catering-parking-true">有り</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-parking-false" name="catering_parking" type="radio" :value="false" v-model="order.catering_parking">
                    <label for="catering-parking-false">無し</label>
                  </div>
                </div>
                <p>駐車料金が発生した場合はお客様負担になります。</p>
              </div>
            </div>

            <div v-if="order.catering_parking" class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">駐車場料金</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-parking-fee-true" name="catering_parking_fee" type="radio" :value="true" v-model="order.catering_parking_fee">
                    <label for="catering-parking-fee-true">有料</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering=parking-fee-false" name="catering_parking_fee" type="radio" :value="false" v-model="order.catering_parking_fee">
                    <label for="catering=parking-fee-false">無料</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <label>入室可能時間</label>
                <select name="catering_avalilable_time" v-model="order.catering_avalilable_time" class="form-control">
                  <option disabled value="">入室可能時間を選択</option>
                  <option v-for="time in timeOptions(9, 20)" :value="time">{{time}}</option>
                </select>
                <p class="my-1 small">
                  &#x203B; 準備に最低1時間はかかります。<br>
                  &#x203B; 会の開始時刻より1時間前に設定をお願いいたします。<br>
                  &#x203B; 人数様により1時間以上かかることもございます。
                </p>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <label>完全撤収時間</label>
                <select name="catering_backdown_time" v-model="order.catering_backdown_time" class="form-control">
                  <option disabled value="">撤収時間を選択</option>
                  <option v-for="time in timeOptions(11, 24)" :value="time">{{time}}</option>
                </select>
                <p class="my-1 small">
                  &#x203B; 会の終了後から30分〜1時間片付けにお時間をいただいております。<br>
                  &#x203B; 人数様により片付けのお時間は変わります。
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-12 mb-1">
              <div class="form-group">
                <label>会場についての補足情報</label>
                <textarea name="catering_remarks" v-model="order.catering_remarks" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div>
        <button @click.prevent="showOrderCautionModal" class="mt-2 btn btn-success" :disabled="!submitable">予約リクエストを送信する</button>
        <Modal title="注文の最終確認" v-if="shouldShowOrderCautionModal" @close="hideOrderCautionModal">
          <OrderCaution></OrderCaution>
          <p class="text-danger">&#x203B; 入力内容の確認後、そのままご予約が完了します。</p>
          <p class="delivery-date-warning">
            配達日は<span class="">{{(order.catering_on || order.delivery_on) | moment("YYYY年MM月DD日")}}</span>です。<br>
            配達日をお間違えないようにお願いします。
          </p>
          <input type="submit" value="予約リクエストを送信する" class="btn btn-block btn-success" @click="create">
        </Modal>
      </div>
      <Loading v-show="loading"></Loading>
    </form>
  </div>
</template>

<script>
  import moment from 'moment';
  import Datepicker from 'vuejs-datepicker';
  import { ja } from 'vuejs-datepicker/dist/locale'
  import _ from 'loadsh';
  import axios from 'axios';
  import qs from 'qs';
  import { orderTypeJa, mealTypeJa }  from '../../utilities/locale';
  import Modal from './Modal';

  try {
    axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    };
  } catch(e) {
    console.log(e);
  }

  import Loading from "../Loading";

  // 新規注文画面
  import DrinkOption from './options/DrinkOption'
  import DishOption from './options/DishOption'
  import DrinkPlanOption from './options/DrinkPlanOption'
  import DrinkSetOption from './options/DrinkSetOption'

  // 見積
  import Estimate from './Estimate'
  import EstimateField from './EstimateField';
  import OrderCaution from './OrderCaution';

  export default {
    components: {
      Modal,
      Loading,
      DrinkOption,
      DishOption,
      DrinkPlanOption,
      DrinkSetOption,
      Estimate,
      EstimateField,
      OrderCaution,
      Datepicker
    },
    props: {
      paymentMethodOptions: Object,
      statusOptions: Object,
      orderProps: Object,
      handleSubmit: Function,
      deliveryPriceTable: Array,
      currentCustomer: Object,
    },
    data: function () {
      return {
        drinkAvailable: false,
        shouldShowEstimateModal: false,
        shouldShowOrderCautionModal: false,
        disabledDates: {
          to: moment().toDate(), // Disable all dates up to specific date
        },
        orderTypeJa,
        mealTypeJa,
        ja: ja,
        errors: {
          messages: {
            quantity: [],
          },
          fullMessages: []
        },
        plan: {},
        drinkSetOptions: [],
        drinkPlanOptions: [],
        drinkOptions: [],
        dishOptions: [],
        calculationResult: {
          total_price: 0,
          delivery_price: 0,
          need_to_be_free_delivery: 0,
          dishes: [],
          drink_plans: [],
          worker: { quantity: 0, price: 0, unit_price: 7500 },
          plate: { quantity: 0, price: 0, unit_price: 30 },
          exothermic_agent: { quantity: 0, price: 0, unit_price: 300 },
          tablecloth: { quantity: 0, price: 0, unit_price: 1000 },
          reduced_tax_rate: { sub_total: 0, tax: 0 },
          normal_tax_rate: { sub_total: 0, tax: 0 }
        },
        loading: false,
        about_venue: '',
        catering_parking: '',
        order: {
          order_type: '',
          plan_name: '',
          plan_price: '',
          quantity: '',
          plate_quantity: '',
          use_plate: false, // 取皿
          use_exothermic_agent: false, // 発熱剤
          use_tablecloth: false, // テーブルクロス
          prefecture: '',
          city: '',
          address: '',
          building_name: '',
          email: '',
          group_name: '',
          customer_name: '',
          payment_method: '',
          need_receipt: null,
          receipt_proviso: '',
          receipt_address: '',
          catering_start_at: '',
          catering_end_at: '',
          delivery_time_range: '',
          catering_admission_procedure: '', // 入館手続き'
          catering_elevator: '', // エレベーター
          catering_wagon: '', // 台車
          catering_parking: '', // 駐車場
          catering_parking_fee: '', // 駐車場料金
          catering_solid_fuel_using: '', // 固形燃料の使用'
          catering_avalilable_time: '', // 入室可能時間'
          catering_backdown_time: '', // 撤収時刻'
          catering_remarks: '', //会場についての補足情報
          alcohol_policy_agreement: false,
          drinks: [],
          drink_plans: [],
          drink_sets: [],
          dishes: [],
          plans: [],
          customizations: [],
        },
      }
    },
    computed: {
      submitable() {
        const { quantity } = this.errors.messages
        // const { fullMessages } = this.errors
        return quantity.length === 0
      },
      isSeventeenPassed() {
        return moment().isAfter(moment().hour(17).minute(0).seconds(0))
      },
      // ドリンクプランで「同じ系統の時間数違い」を選択した場合にエラーメッセージを表示
      invalidDrinkPlanCombinationMessages() {
        const { drink_plans: drinkPlans } = this.order
        if (drinkPlans.length === 0) return []
        const drinkPlanNames = drinkPlans.filter(drinkPlan => drinkPlan.quantity > 0).map(drinkPlan => drinkPlan.name.split(' ')[0])
        const drinkPlanTimes = drinkPlans.filter(drinkPlan => drinkPlan.quantity > 0).map(drinkPlan => drinkPlan.name.split(' ')[1])
        let messages = []
        if (drinkPlanNames.includes('格安飲み放題') && drinkPlanNames.includes('ビール飲み放題')) {
          messages.push('「格安飲み放題」と「ビール飲み放題」を組み合わせることが出来ません。');
        } else if (drinkPlanTimes.includes('2時間') && drinkPlanTimes.includes('3時間')) {
          messages.push('ドリンクプランの「2時間」と「3時間」を組み合わせることが出来ません。');
        }
        return messages
      },
      drinkPlanMinimumQuantityWarning() {
        const { quantity, drink_plans: drinkPlans } = this.order
        let drinkPlanTotalQuantity
        if (drinkPlans.length === 0) {
          drinkPlanTotalQuantity = 0
        } else {
          drinkPlanTotalQuantity = drinkPlans.map(drinkPlan => drinkPlan.quantity).reduce((total, quantity) => total + quantity)
        }
        return quantity && drinkPlanTotalQuantity != 0 && drinkPlanTotalQuantity < quantity
      },
      // 最小注文人数
      minimumQuantity() {
        const { drink_plans: drinkPlans, minimum_quantity: minimumQuantity, minimum_quantity_with_drink_plan: minimumQuantityWithDrinkPlan } = this.order
        if (drinkPlans.length === 0) return minimumQuantity
        if (drinkPlans.filter(drinkPlan => drinkPlan.quantity > 0).length > 0) {
          return minimumQuantityWithDrinkPlan
        } else {
          return minimumQuantity
        }
      },
      // 追加料理の最小注文人数
      dishMinimumQuantity() {
        var minimum = Math.ceil(this.order.quantity / 2);
        return minimum = minimum <= 5  ? 5 : minimum;
      },
      filteredDeliveryPriceTable() {
        return this.deliveryPriceTable.filter((element) => {
          return element.attributes.prefecture == this.order.prefecture
        })
      },
    },
    methods: {
      validatesQuantity() {
        this.errors.messages.quantity = [];
        const { quantity, drink_plans: drinkPlans } = this.order
        if (quantity === '') return;
        if (this.order.quantity < this.minimumQuantity) {
          this.errors.messages.quantity.push(`${this.minimumQuantity}人以上の注文が必要です。`)
        }
        if (this.order.order_type === 'catering' && drinkPlans.length === 0) {
          if (quantity >= 260) this.errors.messages.quantity.push('260人以上の場合は電話でお問い合わせください')
        } else {
          if (quantity >= 250) this.errors.messages.quantity.push('250人以上の場合は電話でお問い合わせください')
        }
      },
      updatePlateQuantity() {
        const { plate_quantity: plateQuantity, quantity } = this.order
        this.order.plate_quantity = quantity
      },
      calculate() {
        axios.get('/api/orders/calculate', {
            params: this.params(),
            paramsSerializer: (params) => {
              return qs.stringify(params, { arrayFormat: 'brackets' })
            }
          },
        ).then((res) => {
          this.calculationResult = res.data
        });
      },
      showEstimateModal() {
        this.shouldShowEstimateModal = true;
      },
      hideEstimateModal() {
        this.shouldShowEstimateModal = false;
      },
      showOrderCautionModal() {
        this.shouldShowOrderCautionModal = true;
      },
      hideOrderCautionModal() {
        this.shouldShowOrderCautionModal = false;
      },
      downloadEstimate() {
        this.loading = true;
        axios.get('/api/orders/download_estimate', {
            responseType: 'blob',
            params: this.params(),
            paramsSerializer: (params) => {
              return qs.stringify(params, { arrayFormat: 'brackets' })
            }
          }
        ).then(response => {
            this.loading = false;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', '見積書.pdf');
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            this.loading = false;
            console.log(error)
          });
      },
      create(e) {
        this.loading = true;
        e.preventDefault()
        axios.post('/api/orders', this.params())
          .then(response => {
            this.loading = false;
            window.location = '/orders/complete';
          })
          .catch(error => {
            console.log(error)
            this.loading = false;
            this.hideOrderCautionModal()
            window.scrollTo(0,0);
            console.log(error.response.data)
            this.errors.fullMessages = error.response.data.errors.full_messages
          });
      },
      params() {
        const { customizations, drinks, drink_sets: drinkSets, drink_plans: drinkPlans, dishes } = this.order
        const params = {
          order: {
            ...this.order,
            customizations_attributes: customizations.map(customization => {
              return { id: customization.id, description: customization.description }
            }),
            drinks_attributes: drinks.map(drink => {
              return {
                id: drink.id,
                name: drink.name,
                kind: drink.kind,
                price: drink.price,
                quantity: drink.quantity,
                unit_name: drink.unit_name
              }
            }),
            drink_plans_attributes: drinkPlans.map(drinkPlan => {
              return {
                id: drinkPlan.id,
                name: drinkPlan.name,
                price: drinkPlan.price,
                quantity: drinkPlan.quantity,
                unit_name: drinkPlan.unit_name
              }
            }),
            drink_sets_attributes: drinkSets.map(drinkSet => {
              return {
                id: drinkSet.id,
                name: drinkSet.name,
                price: drinkSet.price,
                quantity: drinkSet.quantity,
                content: drinkSet.content
              }
            }),
            dishes_attributes: dishes.map(dish => {
              return {
                id: dish.id,
                name: dish.name,
                price: dish.price,
                quantity: dish.quantity,
                unit_name: dish.unit_name
              }
            }),
          }
        }
        return params
      },
      handleDrink(selectedDrink) {
        const { drinks } = this.order
        const { name, unit_name, kind, price, quantity } = selectedDrink
        const drink = drinks.find(drink => drink.name === selectedDrink.name && drink.price === selectedDrink.price);
        if (drink) {
          const index = drinks.indexOf(drink);
          if(quantity === 0 || quantity === '') {
            this.order.drinks = [
              ...drinks.slice(0, index),
              ...drinks.slice(index + 1),
            ];
          } else {
            this.order.drinks = [
              ...drinks.slice(0, index),
              { ...drink, quantity },
              ...drinks.slice(index + 1),
            ];
          }
        } else {
          this.order.drinks = [...drinks, { name, unit_name, kind, price, quantity }]
        }
      },
      handleDrinkSet(selectedDrinkSet) {
        const { drink_sets: drinkSets } = this.order
        const drinkSet = drinkSets.find(drinkSet => drinkSet.name === selectedDrinkSet.name);
        const { name, price, quantity } = selectedDrinkSet
        if (drinkSet) {
          const index = drinkSets.indexOf(drinkSet);
          if(quantity === 0 || quantity === '') {
            this.order.drink_sets = [
              ...drinkSets.slice(0, index),
              ...drinkSets.slice(index + 1),
            ];
          } else {
            this.order.drink_sets = [
              ...drinkSets.slice(0, index),
              { ...drinkSet, quantity },
              ...drinkSets.slice(index + 1),
            ];
          }
        } else {
          this.order.drink_sets = [...drinkSets, { name, price, quantity }]
        }
      },
      handleDrinkPlan(selectedDrinkPlan) {
        const { drink_plans: drinkPlans } = this.order
        const drinkPlan = drinkPlans.find(drinkPlan => drinkPlan.name === selectedDrinkPlan.name);
        const { name, unit_name, price, quantity } = selectedDrinkPlan
        if (drinkPlan) {
          const index = drinkPlans.indexOf(drinkPlan);
          if(quantity === 0 || quantity === '') {
            this.order.drink_plans = [
              ...drinkPlans.slice(0, index),
              ...drinkPlans.slice(index + 1),
            ];
          } else {
            this.order.drink_plans = [
              ...drinkPlans.slice(0, index),
              { ...drinkPlan, quantity },
              ...drinkPlans.slice(index + 1),
            ];
          }
        } else {
          if(quantity === 0 || quantity === '') return
          this.order.drink_plans = [...drinkPlans, { name, unit_name, price, quantity }]
        }
      },
      handleDish(selectedDish) {
        const { dishes } = this.order
        const { name, unit_name, price, quantity } = selectedDish
        const dish = dishes.find(dish => dish.name === selectedDish.name && dish.price === selectedDish.price);
        if (dish) {
          const index = dishes.indexOf(dish);
          if(quantity === 0 || quantity === '') {
            this.order.dishes = [
              ...dishes.slice(0, index),
              ...dishes.slice(index + 1),
            ];
          } else {
            this.order.dishes = [
              ...dishes.slice(0, index),
              { ...dish, quantity },
              ...dishes.slice(index + 1),
            ];
          }
        } else {
          const index = dishes.indexOf(dish);
          this.order.dishes = [...dishes, { name, unit_name, price, quantity }]
        }
      },
      fetchDrinks() {
        axios.get('/api/drinks').then((res) => {
          this.drinkOptions = res.data;
        });
      },
      fetchDrinkPlans() {
        axios.get('/api/drink_plans').then((res) => {
          this.drinkPlanOptions = res.data;
        });
      },
      fetchDrinkSets() {
        axios.get('/api/drink_sets').then((res) => {
          this.drinkSetOptions = res.data;
        });
      },
      fetchDishes() {
        axios.get('/api/dishes').then((res) => {
          this.dishOptions = res.data;
        });
      },
      fetchOrder(id) {
        return axios.get(`/api/orders/${id}`).then((res) => {
          this.order = { ...this.order, ...res.data }
        });
      },
      fetchPlan(id) {
        return axios.get(`/api/plans/${id}`).then((res) => {
          this.plan = res.data;
        });
      },
      timeOptions(start, end) {
        var options = []
        _.range(start, end).forEach(h => {
          options.push(`${h}:00`)
          options.push(`${h}:15`)
          options.push(`${h}:30`)
          options.push(`${h}:45`)
        });
        options.push(`${end}:00`)
        return options
      },
      timeRangeOptions(start, end) {
        var options = []
        _.range(start, end).forEach(h => {
          options.push(`${h}:00 〜 ${h + 1}:00`)
          options.push(`${h}:15 〜 ${h + 1}:15`)
          options.push(`${h}:30 〜 ${h + 1}:30`)
          options.push(`${h}:45 〜 ${h + 1}:45`)
        });
        options.push(`${end}:00 〜 ${end + 1}:00 `)
        return options
      },
    },
    mounted() {
      const { plan_id: planId } = this.orderProps
      if (planId) this.fetchPlan(planId);
      this.fetchDrinks();
      this.fetchDrinkPlans();
      this.fetchDrinkSets();
      this.fetchDishes();
    },
    beforeCreate() {
    },
    created() {
      // 新規作成の場合はpropsから受け取り、編集の場合はfetchする
      const { id } = this.orderProps
      if (id) {
        this.fetchOrder(id)
      } else {
        this.order = { ...this.order, ...this.orderProps }
        if (this.currentCustomer) {
          const { email, tel, name, group_name: groupName } = this.currentCustomer;
          this.order.email = email;
          this.order.tel = tel;
          this.order.customer_name = name;
          this.order.group_name = groupName;
        }
      }
    },
    updated() {
    },
  }
</script>
